import GrabbableWindow from './GrabbableWindow.js';

export default class ColorPicker {
  constructor(colorManager, colorPalette) {
    this._colorPalette = colorPalette;
    this._colorManager = colorManager;
    this._colorManagerRegisterIdx = colorManager.register(color => this._setColor(color));
    this._elColorPicker = document.querySelector('#colorPicker');
    this._elHS = this._elColorPicker.querySelector('.hs');
    this._elHSCursor = this._elColorPicker.querySelector('.hsCursor');
    this._elV = this._elColorPicker.querySelector('.v');
    this._elA = this._elColorPicker.querySelector('.a');
    this._elFavorite = this._elColorPicker.querySelector('.favorite');
    this._elColorText = this._elColorPicker.querySelector('.colorText');
    this._objElSpecificColor = {
      transparent: {
        elem: this._elColorPicker.querySelector('.specificColor.transparent'),
        color: [0, 0, 0, 0],
      },
    };
    this._grabbableWindow = new GrabbableWindow(this._elColorPicker);
    this._isCursorDragging = false;

    //--- 閉じる
    this._elColorPicker.querySelector('.close').addEventListener('click', () => {
      this.show(false);
    });
    
    //--- HSを表すキャンバスの操作に応じてカーソルとVおよびAを表すスライダーの背景色を更新
    this._elHS.addEventListener('mousedown', e => {
      if(e.button === 0 && !this._isCursorDragging) {
        this._isCursorDragging = true;
        this._setHS(e.clientX, e.clientY);
        document.body.classList.add('forceCursorPointer');
      }
    });
    window.addEventListener('mousemove', e => {
      if(this._isCursorDragging) {
        if(e.buttons & 1) {
          this._setHS(e.clientX, e.clientY);
          const {x, y} = this._elHSCursor.getBoundingClientRect();
        } else {
          this._isCursorDragging = false;
          document.body.classList.remove('forceCursorPointer');
        }
      }
    });

    //--- Vを表すスライダーの操作に応じてHSを表すキャンバスおよびAを表すスライダーを描画し直す
    this._elV.addEventListener('input', () => {
      this._drawHS();
      this._drawA();
      this._updateSelectedColor();
    });
  
    //--- Aを表すスライダーの操作に応じてHSを表すキャンバスおよびVを表すスライダーを描画し直す
    this._elA.addEventListener('input', () => {
      this._drawHS();
      this._drawV();
      this._updateSelectedColor();
    });

    //--- お気に入り登録ボタン
    this._elFavorite.addEventListener('click', () => {
      this._colorPalette.addColor(this._colorManager.get());
      this._colorPalette.show(true);
    });

    //--- 特定カラーをクリック
    for(const k in this._objElSpecificColor) {
      const elSpecificColor = this._objElSpecificColor[k].elem;
      elSpecificColor.addEventListener('click', () => {
        this._moveSpecificColorCursor(k);
        this._updateSelectedColor();
      });
    }

    //--- テキストの内容を選択色やカラーピッカーに反映
    this._elColorText.addEventListener('input', () => {
      let found;
      let r, g, b, a;
      if(found = this._elColorText.value.match(/rgba?\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(1|0|0?\.\d+)\s*)?\)/)) {
        r = parseInt(found[1]);
        g = parseInt(found[2]);
        b = parseInt(found[3]);
        a = found[4] === undefined ? 1 : parseFloat(found[4]);
        if(!(r < 256 && g < 256 && b < 256)) {
          this._elColorText.setCustomValidity('invalid');
          return;
        }
      } else if(found = this._elColorText.value.match(/#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/)) {
        r = parseInt(found[1], 16);
        g = parseInt(found[2], 16);
        b = parseInt(found[3], 16);
        a = found[4] === undefined ? 1 : parseInt(found[4], 16) / 255;
      } else if(found = this._elColorText.value.match(/#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])?/)) {
        r = parseInt(found[1] + found[1], 16);
        g = parseInt(found[2] + found[2], 16);
        b = parseInt(found[3] + found[3], 16);
        a = found[4] === undefined ? 1 : parseInt(found[4] + found[4], 16) / 255;
      } else {
        this._elColorText.setCustomValidity('invalid');
        return;
      }

      if(0 < a && a < 1) {
        this._elColorPicker.classList.remove('hideAlpha');
      }

      this._setState(r, g, b, a);
      this._colorManager.set([r, g, b, a], this._colorManagerRegisterIdx);
      this._elColorText.setCustomValidity('');
    });
    
    this._elHSCursor.style.top = '0px';
    this._elHSCursor.style.left = '0px';
    this._drawHS();
    this._drawV();
    this._drawA();
  }

  //--- カラーピッカーの表示／非表示を切り替え
  show(yes) {
    if(yes){
      this._elColorPicker.classList.remove('hidden');
    } else {
      this._elColorPicker.classList.add('hidden');
    }
    document.querySelector('#toolOptionGroup [name="colorPicker"]').checked = yes;
  }

  //--- カラーピッカーのウィンドウを移動
  _moveWindow(x, y, width, height) {
    if(x < 0) x = 0;
    if(window.innerWidth < x + width) x = window.innerWidth - width;
    if(y < 0) y = 0;
    if(window.innerHeight < y + height) y = window.innerHeight - height;
    this._elColorPicker.style.left = x.toFixed() + 'px';
    this._elColorPicker.style.top = y.toFixed() + 'px';
  }

  //--- HSを表すキャンバスの操作に応じてカーソルとVおよびAを表すスライダーの背景色を更新
  _setHS(clientX, clientY) {
    this._moveHSCursor(clientX, clientY)
    this._drawV();
    this._drawA();
    this._updateSelectedColor();
  }
  _moveHSCursor(clientX, clientY) {
    const rect = this._elHS.getBoundingClientRect();
    const offsetX = Math.max(0, Math.min(clientX - rect.x, rect.width));
    const offsetY = Math.max(0, Math.min(clientY - rect.y, rect.height));
    this._elHSCursor.style.left = offsetX + 'px';
    this._elHSCursor.style.top = offsetY + 'px';
  }

  //--- HSを表すキャンバスを描画
  _drawHS() {
    const v = this._getV();
    const ctx = this._elHS.getContext('2d');
    const width = this._elHS.width;
    const height = this._elHS.height;
    const image = ctx.createImageData(width, height);

    for(let y = 0; y < height; ++y) {
      for(let x = 0; x < width; ++x) {
        const i = ((y * width) + x) * 4;
        const h = x * 360 / width;
        const s = 1 - y / height;
        const a = Math.floor(this._getA() * 255);
        const rgba = [...ColorPicker.hsv2rgb([h, s, v]).map(Math.floor), a];
        image.data.set(rgba, i);
      }
    }
    ctx.putImageData(image, 0, 0);
    ctx.drawImage(this._elHS, 0, 0, width, height, 0, 0, this._elHS.width, this._elHS.height);
  }

  //--- HSを表すキャンバスの状態からHとSの値を計算
  _getHS() {
    const rect = this._elHS.getBoundingClientRect();
    const h = parseFloat(this._elHSCursor.style.left) / rect.width * 360;
    const s = 1 - (parseFloat(this._elHSCursor.style.top) / rect.height);
    return [h, s];
  }

  //--- Vを表すスライダーの背景色を更新
  _drawV() {
    const [h, s] = this._getHS();
    const [r, g, b] = ColorPicker.hsv2rgb([h, s, 1]).map(Math.floor);
    const a = this._getA();
    this._elV.style.backgroundImage = `linear-gradient(to right, rgba(0,0,0,${a}), rgba(${r},${g},${b},${a}))`;
  }

  //--- Vを表すスライダーの状態からVの値を計算
  _getV() {
    return parseFloat(this._elV.value);
  }

  //--- Aを表すスライダーの背景色を更新
  _drawA() {
    const [h, s] = this._getHS();
    const v = this._getV();
    const [r, g, b] = ColorPicker.hsv2rgb([h, s, v]).map(Math.floor);
    this._elA.style.backgroundImage = `linear-gradient(to right, rgba(${r},${g},${b},0), rgba(${r},${g},${b},1))`;
  }

  //--- Aを表すスライダーの状態からAの値を計算
  _getA() {
    return parseFloat(this._elA.value);
  }

  //--- 特定カラー
  _getSpecificColor() {
    const cursorRect = this._elHSCursor.getBoundingClientRect();
    const cursorX = cursorRect.x + cursorRect.width / 2;
    const cursorY = cursorRect.y + cursorRect.height / 2;
    for(const k in this._objElSpecificColor) {
      const elSpecificColor = this._objElSpecificColor[k].elem;
      const rect = elSpecificColor.getBoundingClientRect();
      if(rect.x <= cursorX && cursorX < rect.right && rect.y <= cursorY && cursorY < rect.bottom) {
        return this._objElSpecificColor[k].color;
      }
    }
    return null;
  }
  _moveSpecificColorCursor(name) {
    const rect = this._objElSpecificColor[name].elem.getBoundingClientRect();
    const rect2 = this._elHS.getBoundingClientRect();
    const offsetX = rect.x + rect.width / 2 - rect2.x;
    const offsetY = rect.y + rect.height / 2 - rect2.y;
    this._elHSCursor.style.left = offsetX.toFixed() + 'px';
    this._elHSCursor.style.top = offsetY.toFixed() + 'px';
  }

  //--- 指定色をテキストに設定
  _setColorText(r, g, b, a) {
    if(a === 1) {
      this._elColorText.value = `rgb(${r},${g},${b})`;
    } else {
      this._elColorText.value = `rgba(${r},${g},${b},${Math.floor(a * 100) / 100})`;
    }
    this._elColorText.setCustomValidity('');
  }

  //--- カラーピッカーの表示状態から選択色の内部データと表示を更新
  _updateSelectedColor() {
    const color = this._calcColorFromState();
    this._setColorText(...color);
    this._colorManager.set(color, this._colorManagerRegisterIdx);
  }
  _calcColorFromState() {
    const color = this._getSpecificColor();
    if(color) {
      return color;
    } else {
      const [h, s] = this._getHS();
      const v = this._getV();
      const [r, g, b] = ColorPicker.hsv2rgb([h, s, v]).map(Math.floor);
      const a = this._getA();
      return [r, g, b, a];
    }
  }

  //--- 指定色からカラーピッカーの表示状態を更新
  _setColor(color) {
    this._setState(...color);
    this._setColorText(...color);
  }
  _setState(r, g, b, a) {
    if(a == 0) {
      this._moveSpecificColorCursor('transparent');
    /*} else if(r == 0 && g == 0 && b == 0 && a == 1) {
      this._moveSpecificColorCursor('black');
    } else if(r == 255 && g == 255 && b == 255 && a == 1) {
      this._moveSpecificColorCursor('white');*/
    } else {
      const rect = this._elHS.getBoundingClientRect();
      const [h, s, v] = ColorPicker.rgb2hsv([r, g, b]);
      this._elHSCursor.style.left = rect.width * h / 360 + 'px';
      this._elHSCursor.style.top  = (1 - s) * rect.height + 'px';
      this._elV.value = v;
      this._elA.value = a;
      this._drawHS();
      this._drawV();
      this._drawA();
    }
  }
  redraw() {
    this._setColor(this._colorManager.get());
  }

  //--- https://lab.syncer.jp/Web/JavaScript/Snippet/66/
  static rgb2hsv ( rgb ) {
    var r = rgb[0] / 255 ;
    var g = rgb[1] / 255 ;
    var b = rgb[2] / 255 ;

    var max = Math.max( r, g, b ) ;
    var min = Math.min( r, g, b ) ;
    var diff = max - min ;

    var h = 0 ;

    switch( min ) {
      case max :
        h = 0 ;
      break ;

      case r :
        h = (60 * ((b - g) / diff)) + 180 ;
      break ;

      case g :
        h = (60 * ((r - b) / diff)) + 300 ;
      break ;

      case b :
        h = (60 * ((g - r) / diff)) + 60 ;
      break ;
    }

    var s = max == 0 ? 0 : diff / max ;
    var v = max ;

    return [ h, s, v ] ;
  }

  //--- https://lab.syncer.jp/Web/JavaScript/Snippet/67/
  static hsv2rgb ( hsv ) {
    var h = hsv[0] / 60 ;
    var s = hsv[1] ;
    var v = hsv[2] ;
    if ( s == 0 ) return [ v * 255, v * 255, v * 255 ] ;

    var rgb ;
    var i = parseInt( h ) ;
    var f = h - i ;
    var v1 = v * (1 - s) ;
    var v2 = v * (1 - s * f) ;
    var v3 = v * (1 - s * (1 - f)) ;

    switch( i ) {
      case 0 :
      case 6 :
        rgb = [ v, v3, v1 ] ;
      break ;

      case 1 :
        rgb = [ v2, v, v1 ] ;
      break ;

      case 2 :
        rgb = [ v1, v, v3 ] ;
      break ;

      case 3 :
        rgb = [ v1, v2, v ] ;
      break ;

      case 4 :
        rgb = [ v3, v1, v ] ;
      break ;

      case 5 :
        rgb = [ v, v1, v2 ] ;
      break ;
    }

    return rgb.map( function( value ) {
      return value * 255 ;
    } ) ;
  }
}
